import * as React from "react";
import PropTypes from "prop-types";
import StorageUtils from "@src/utils/storageUtils";

const AdminContext = React.createContext();
AdminContext.displayName = "AdminContext";

const useAdminContext = () => React.useContext(AdminContext);

const AdminContentProvider = ({ children, adminData }) => {
  if (!adminData) {
    adminData = [];
  }
  const [customers, setCustomers] = React.useState(adminData); // "customers" is only set via this contex constructor (setCustomers cannot be used anywhere else)
  const [selectedCustomer, setSelectedCustomer] = React.useState(null);

  const memoizedCustomers = React.useMemo(() => customers, [customers]);
  const contextValues = {
    customers: memoizedCustomers, // expected to remain stable across app renders
    selectedCustomer,
    setSelectedCustomer,
    setCustomers,
  };

  return (
    <AdminContext.Provider value={contextValues}>
      {children}
    </AdminContext.Provider>
  );
};

AdminContentProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { useAdminContext };

export default AdminContentProvider;
